"use client";
import { CN_PRODUCT } from "@/utils/const";
import Image from "next/image";
import NEW_SHOPPER from "@/images/icon/new-shopper.png";
import NEW_SHOPPER_ZH_CN from "@/assets/images/NEW_SHOPPER_ZH_CN.png";
import cookieUtils from "@/utils/cookieUtils";

type Props = {
  landPageUrl: string;
};

export default function NewShopperActivity({ landPageUrl }: Props) {
  // -------------- prepare image -------------------- //
  const currentLang = cookieUtils.getCookie("_lang") || "en_GB";
  let image =
    currentLang === "en_GB"
      ? {
          src: NEW_SHOPPER,
          width: 149,
          height: 24,
        }
      : {
          src: NEW_SHOPPER_ZH_CN,
          width: 92,
          height: 24,
        };
  return (
    <div className={CN_PRODUCT("new-shopper")}>
      <Image src={image.src} width={image.width} height={image.height} alt="new shopper" />
    </div>
  );
}
